export const environment = {
  production: false,
  uat: true,
  staging: false,
  development: false,
  environment: 'uat',
  baseUrl: 'https://custom-tracwater-sw-api.tracwater.net.au',
  portalId: '65a63702295832cdfb0089a3',
  portalTypeId: '689596b618f8a8985a2aeb91',
  predictionURL: 'https://testing-predection.tracwater.online/api/v1',
};
